import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h6","key":"svg-0"}],["path",{"d":"M6 9v6","key":"svg-1"}],["path",{"d":"M18 19v-14l-4 4","key":"svg-2"}]]

const IconExposurePlus1 = createReactComponent('outline', 'exposure-plus-1', 'ExposurePlus1', __iconNode);

export default IconExposurePlus1;